// table-columns
import i18n from '@/lang';

export const columns = [
  // 系统编号
  { prop: 'serialNo', label: i18n.t('basicData.SystemNumber'), width: 180, align: 'left' },
  // 合同编号
  { prop: 'contractNo', label: i18n.t('basicData.ContractNumber'), width: 180, align: 'left' },
  // 客户编号
  { prop: 'customerId', label: i18n.t('basicData.CustomerNumber'), width: 120, align: 'left' },
  // 客户名称
  { prop: 'customerName', label: i18n.t('basicData.CustomerName'), width: 180, align: 'left' },
  // 客户别名
  { prop: 'customerAlias', label: i18n.t('orderCenterCont.CustomerAlias'), width: 180, align: 'left' },
  // 首次下单日期
  { prop: 'firstOrderTime', label: i18n.t('basicData.FirstOrderDate'), width: 160, align: 'left' },
  // 合同类型
  { prop: 'type', label: i18n.t('basicData.ContractType'), width: 160, align: 'left' },
  // 合同开始日期
  { prop: 'startDate', label: i18n.t('basicData.ContractStartDate'), width: 160, align: 'left' },
  // 合同结束日期
  { prop: 'endDate', label: i18n.t('basicData.ContractEndDate'), width: 160, align: 'left' },
  // 付款账期
  { prop: 'paymentDays', label: i18n.t('basicData.PaymentTerms'), width: 100, align: 'left' },
  // 合同状态
  { prop: 'status', label: i18n.t('basicData.ContractStatus'), width: 100, align: 'left' },
  // 业务类型
  { prop: 'businessTypeName', label: i18n.t('collectionCenter.businessT'), width: 200, align: 'left' },
  // 业务对接人
  { prop: 'businessContactName', label: i18n.t('basicData.BusinessContactPerson'), width: 160, align: 'left' },
  // 账单制作人
  { prop: 'billCreatorName', label: i18n.t('basicData.BillMaker'), width: 180, align: 'left' },
  // 账单审核人
  { prop: 'billAuditorName', label: i18n.t('basicData.BillReviewer'), width: 180, align: 'left' },
  // 扫描件
  { prop: 'fileList', label: i18n.t('basicData.ScannedDocuments'), width: 200, align: 'left' },
  // 创建人
  { prop: 'createUserName', label: i18n.t('basicData.CreatePeople'), width: 160, align: 'left' },
  // 创建时间
  { prop: 'createTime', label: i18n.t('basicData.CreationTime'), width: 160, align: 'left' },
  // 修改人
  { prop: 'updateUserName', label: i18n.t('basicData.ModifyThePerson'), width: 160, align: 'left' },
  // 修改时间
  { prop: 'updateTime', label: i18n.t('basicData.ModificationTime'), width: 160, align: 'left' }
];

